var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initialized)?_c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('side-bar',{scopedSlots:_vm._u([{key:"links",fn:function(props){return [(_vm.$can('read', 'BOOKINGS'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('message.bookings'),
          icon: 'now-ui-icons ui-1_calendar-60',
          path: '/bookings'
        }}}):_vm._e(),(_vm.$can('read', 'ACTIVITY'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Activity',
          icon: 'now-ui-icons media-2_sound-wave',
          path: '/activity'
        }}}):_vm._e(),(_vm.$can('read', 'MANAGEMENT'))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('message.management'),
          icon: 'now-ui-icons business_badge'
        }}},[(_vm.$can('read', 'ROSTER'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('message.roster'),
            path: '/management/roster'
          }}}):_vm._e(),(_vm.$can('read', 'ROSTER'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('message.rosterV2'),
            path: '/management/roster-v2',
            mini: 'RV2'
          }}}):_vm._e(),(_vm.$can('read', 'EMPLOYEES'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('message.employees'),
            path: '/management/employees'
          }}}):_vm._e(),(_vm.$can('read', 'RESOURCES'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('message.resources'),
            path: '/management/resources'
          }}}):_vm._e(),(_vm.$can('read', 'SERVICES'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('message.services'),
            path: '/management/services'
          }}}):_vm._e()],1):_vm._e(),(_vm.$can('read', 'ACCOUNTING'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Accounting',
          icon: 'now-ui-icons business_money-coins'
        }}},[(_vm.$can('read', 'INVOICES'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('message.invoices'),
            path: '/invoices'
          }}}):_vm._e(),(_vm.$can('read', 'RECURRING_INVOICES'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('message.recurringInvoices'),
            path: '/recurring-invoices'
          }}}):_vm._e(),(_vm.$can('read', 'CREDIT_NOTES'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('message.creditNotes'),
            icon: 'now-ui-icons files_paper',
            path: '/credit-notes'
          }}}):_vm._e(),(_vm.$can('read', 'CUSTOMERS'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('message.customers'),
            path: '/customers'
          }}}):_vm._e(),(_vm.$can('read', 'BOOKINGS'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('message.bookingsV2'),
            path: '/accounting/bookings-v2',
            mini: 'BV2'
          }}}):_vm._e()],1):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: 'Settings',
          icon: 'now-ui-icons loader_gear'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Business Details',
            path: '/settings/business-details'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Accounting',
            path: '/settings/accounting'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('message.rosterSettingsTitle'),
            path: '/settings/rostering'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Shopfront',
            path: '/settings/shopfront'
          }}})],1)]}}],null,false,3657989477)}),_c('div',{staticClass:"main-panel"},[_c('top-navbar',{on:{"on-logout":_vm.handleLogout}}),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('router-view')],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }